/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { GridQuery as h } from "../common/table-query.mjs";
import { createTable as u, wrapTable as a } from "../common/utils.mjs";
const y = (s) => {
  const o = new h(s), t = o.content();
  let r;
  const e = o.header();
  if (e.childNodes.length > 1 && e.removeChild(e.childNodes[1]), e.childNodes[0].childNodes.forEach((c) => c.style.top = 0), t) {
    const c = [t.querySelector("colgroup")], n = [e], d = [t.querySelector("tbody")], l = o.footer(), i = l ? [l.querySelector("tfoot")] : [];
    r = u(c, n, d, i);
  } else
    r = a(o.table().cloneNode(!0));
  return r;
};
export {
  y as exportElement
};
